import React, { useState } from 'react';
import { Box, Button, Tooltip } from '@mui/material';

import PharmacyTable from './PharmacyTable';
import RegionManager from './RegionManager';
import MathReportTable from './MathReportTable'; 

interface ReportsProps {
    setSelectedIndex: (index: number) => void;
  }  

const MathReportMenu: React.FC<ReportsProps> = ({setSelectedIndex}) => {
  const [activeModule, setActiveModule] = useState<'RegionManager' | 'PharmacyTable' | 'MathReportTable' | null>('PharmacyTable');

  const handleReportClick = () => {
    setSelectedIndex(3);
  };

  return (
    <Box sx={{ maxWidth: '100%', overflowX: 'auto' }}>

      <Box sx={{ mb: 2, display: 'flex', gap: '10px' }}>
        <Tooltip title="Форма заполняемая аптекой" enterDelay={1000} arrow>
          <Button
            variant="contained"
            onClick={() => setActiveModule('PharmacyTable')}
          >
            Табилца выручки
          </Button>
        </Tooltip>

        <Tooltip title="Список регионов при создании/редактировании пользователя" enterDelay={1000} arrow>
          <Button
            variant="contained"
            onClick={() => setActiveModule('RegionManager')}
          >
            Список регионов
          </Button>
        </Tooltip>

        {localStorage.getItem('role') === 'admin' && (
        <Tooltip title="Поля в мат отчете" enterDelay={1000} arrow>
          <Button
            variant="contained"
            onClick={() => setActiveModule('MathReportTable')}
          >
            Поля в мат отчете
          </Button>
        </Tooltip>
      )}
      </Box>

      {activeModule === 'PharmacyTable' && <PharmacyTable />}
      {activeModule === 'RegionManager' && <RegionManager />}
      {activeModule === 'MathReportTable' && <MathReportTable />}

    </Box>
  );
};

export default MathReportMenu;